import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';
import LabelHint from '../LabelHint';
import styled from 'styled-components';

const Div = styled.div`
  display: ${props => props.inline ? 'inline-block' : 'block'};
  width: ${props => props.small ? '85px' : '100%' };
  
  & + div {
    margin-left: ${ props => props.inline ? '10px' : 0 };
  }
`;

const Field = styled.input`
  background-color: ${(theme) => theme.secondary };
  border: 1px solid rgba(255, 225, 191, 0.47);
  border-radius: 4px;
  color: ${(theme) => theme.background };
  height: 50px;
  padding: 5px;
  transition: all 0.2s;
  width: 100%;
  
  &:focus {
    outline: ${(theme) => `1px solid ${theme.background}` };
    border: ${(theme) => `1px solid red` };
  }


  &:hover {
    border-color: ${(theme) => theme.background };
  }
  
    &.has-error {
    border: 1px solid #ab3029;
  }
`;

const Error = styled.div`
  color: #ab3029;
  margin-top: 3px;
`;

const Hint = styled.div`
  font-size: 15px;
  color: #444444;
  margin-top: 4px;
`;

const StyledField = ({ field, form, small, inline, hint, label, ...props }) => { return (
    <Div small={small} inline={ inline }>
      { hint ? <LabelHint hint={ hint }>{ label } </LabelHint> : <label>{ label }</label> }
      <Field {...field} {...props} className={ form.errors[field.name] ? 'has-error' : '' } />
      <Error>{ form.errors[field.name] }</Error>
    </Div>); };

export default StyledField;



// WEBPACK FOOTER //
// ./src/components/StyledField/StyledField.js